module.exports = __webpack_public_path__ + "static/media/028.51650522.jpg";